module.exports = __webpack_public_path__ + "static/Henri_Crozel-9207313e013b5e2351cca6d5c840d0d5.webp";